<template>
  <div>
    <div @click="open">
      <el-input
        :placeholder="$lange == 'en' ? 'Select' : '选择'"
        disabled
        v-model="name"
      >
        <!-- -->
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>

    <el-dialog
      v-loading="loading"
      :title="$lange == 'en' ? 'Select' : '选择内容'"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      width="80%"
      append-to-body
    >
      <div class="step_wrap">
        <el-steps :active="index" finish-status="success">
          <el-step>
            <h3 slot="title">项目</h3>
          </el-step>
          <el-step>
            <h3 slot="title">单元</h3>
          </el-step>
          <el-step title="阶段">
            <h3 slot="title">阶段</h3>
          </el-step>
          <el-step>
            <h3 slot="title">确认</h3>
          </el-step>
        </el-steps>
      </div>
      <template v-if="!loading">
        <template v-if="ids.length < 4">
          <el-card shadow="never" v-if="index == 3">
            <div>
              <el-button
                :type="processType == '' ? 'primary' : ''"
                @click="changeProcessType('')"
                >全部类</el-button
              >
              <el-button
                :type="processType == 'FC101' ? 'primary' : ''"
                @click="changeProcessType('FC101')"
                >机械类</el-button
              >
              <el-button
                :type="processType == 'FC104' ? 'primary' : ''"
                @click="changeProcessType('FC104')"
                >电气类</el-button
              >
              <el-button
                :type="processType == 'FC108' ? 'primary' : ''"
                @click="changeProcessType('FC108')"
                >调试类</el-button
              >
            </div>
          </el-card>
          <div class="selectContent">
            <cc-table
              :loadData="true"
              :config="tableConfig1"
              :params="tableParams"
              :refeshParams="refeshTable"
              @rowClick="rowClick"
              :openRowClick="false"
              size="medium"
              :buttonsWidth="80"
            ></cc-table>
          </div>
        </template>
        <template v-else>
          <div class="tips">已完成内容选择请点击确认</div>
        </template>
        <div class="button_box">
          <el-button @click="top" :disabled="index == 0">上一步</el-button>
          <el-button type="primary" :disabled="ids.length < 4" @click="save"
            >确认</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  model: {
    prop: "value",
    event: "click",
  },
  props: {
    formData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      ids: [],
      loading: true,
      index: 0,
      name: "",
      nameArr: [],
      dialog: false,
      tableConfig1: {
        api: "admin/fsb/workshop/daily/dailyInfo/query",
        showPager: true,
        columns: [
          // {
          //   prop: "id",
          //   lable: "id",
          //   minWidth: 150,
          // },
          {
            prop: "name",
            lable: "名称",
            minWidth: 150,
          },
        ],
        buttons: [
          {
            name: "选择",
            click: (row) => {
              this.getChangConfig();
              this.index += 1;
              this.tableParams.type += 1;
              this.ids.push(row.id);
              if (this.index <= 3) {
                this.tableParams.ids = row.id;
              }
              if (row.processId) {
                this.processId = row.processId;
              }
              this.nameArr.push(row.name);
              console.log(this.tableParams.type);
              if (this.tableParams.type == 2) {
                this.autoNext();
              }
            },
            btnColor: "font-weight",
          },
        ],
      },
      tableParams: {
        // ids: 0
      },
      refeshTable: -1,
      user: {},
      processType: "",
    };
  },
  methods: {
    rowClick(row) {
      this.index += 1;
      this.tableParams.type += 1;
      this.ids.push(row.id);
      if (this.index <= 3) {
        this.tableParams.ids = row.id;
      }
      if (row.processId) {
        this.processId = row.processId;
      }
      this.nameArr.push(row.name);
      console.log(this.tableParams.type);
      if (this.tableParams.type == 2) {
        this.autoNext();
      }
    },
    changeProcessType(e) {
      if (e == "FC104") {
        this.processType = process.env.VUE_APP_FC104;
        this.tableParams.processType = process.env.VUE_APP_FC104;
      } else if (e == "FC101") {
        this.processType = process.env.VUE_APP_FC101;
        this.tableParams.processType = process.env.VUE_APP_FC101;
      } else if (e == "FC108") {
        this.processType = process.env.VUE_APP_FC108;
        this.tableParams.processType = process.env.VUE_APP_FC108;
      } else {
        this.processType = "";
        this.tableParams.processType = "";
      }
      this.refeshTable = new Date().getTime();
    },
    //判斷只有一條時自動選中並且走下一步
    autoNext() {
      this.ccRequest
        .do("admin/fsb/workshop/daily/dailyInfo/query", this.tableParams, "GET")
        .then((res) => {
          if (res.rows.length == 1) {
            let row = res.rows[0];
            this.index += 1;
            this.tableParams.type += 1;
            this.ids.push(row.id);
            if (this.index <= 3) {
              this.tableParams.ids = row.id;
            }
            if (row.processId) {
              this.processId = row.processId;
            }
            this.nameArr.push(row.name);
            // if (this.tableParams.type < 4) {
            //   this.autoNext();
            // }
          }
        });
    },
    top() {
      try {
        this.index -= 1;
        if (this.index == 0) {
          this.ids.pop();
          this.nameArr.pop();
          this.tableParams = {
            type: 0,
            userId: this.user.id,
          };
        } else {
          this.tableParams.type -= 1;
          this.ids.pop();
          this.nameArr.pop();
          this.tableParams.ids = this.ids[this.ids.length - 1];
        }
        // if (this.index != 3) {
        delete this.tableParams.processType;
        // }
        this.processType = "";
        this.refeshTable = new Date().getTime();
        if (this.tableParams.type > 0) {
          this.ccRequest
            .do(
              "admin/fsb/workshop/daily/dailyInfo/query",
              this.tableParams,
              "GET"
            )
            .then((res) => {
              if (res.rows.length == 1) {
                this.top();
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
    open() {
      if (this.formData.ids) {
        let formData = JSON.parse(JSON.stringify(this.formData));
        this.ids = formData.ids.ids;
        // this.nameArr = formData.ids.name;
        // this.name = formData.ids.name.join("-");
        this.index = 4;
        this.tableParams.type = 4;
      } else {
        this.tableParams = {
          type: 0,
          userId: this.user.id,
        };
      }
      this.ccRequest.do("validate", {}, "GET").then((res) => {
        this.user = res;
        if (this.formData.ids) {
          this.tableParams.userId = res.id;
        }
        this.loading = false;
        this.dialog = true;
      });
    },
    doSearch(e) {
      this.tableParams = { ...e };
    },
    save() {
      this.dialog = false;
      // this.name = this.ids.join("————");
      // this.name = this.processId;
      // this.name = this.nameArr.join("-");
      this.name = this.nameArr[this.nameArr.length - 1];
      console.log(this.processId);
      let data = {
        ids: this.processId.split("-"),
        name: this.nameArr,
      };
      this.$emit("click", data);
      console.log(this.nameArr);
    },
    getChangConfig() {
      this.ccRequest
        .do("admin/fsb/workshop/daily/getDeptType", {}, "GET")
        .then((res) => {
          // res = "FC104";
          if(res){
            this.changeProcessType(res);
          }
        });
    },
  },
  mounted() {
    this.getChangConfig();
    this.ccRequest.do("validate", {}, "GET").then((res) => {
      this.user = res;
      if (this.formData.ids) {
        let formData = JSON.parse(JSON.stringify(this.formData));
        console.log(this.formData);
        this.tableParams.userId = res.id;
        this.ids = formData.ids.ids;
        this.nameArr = formData.ids.name;
        // this.name = formData.ids.name.join("-");
        if (formData.content) {
          this.name = formData.content;
        } else {
          this.name = formData.ids.name[formData.ids.name.length - 1];
        }
        this.tableParams.userId = res.id;
      }
    });
  },
};
</script>
<style scoped>
.button_box {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.tips {
  text-align: center;
  font-size: 28px;
}
.step_wrap {
  margin-bottom: 10px;
}
</style>
<style>
.selectContent .cell span {
  font-weight: 700 !important;
}
</style>
